import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, Globe, RadioTower } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import { useSite } from "../context/SiteContext";

const Header = () => {
  const { t, lang, toggleLang } = useLanguage();
  const { settings, assetUrl } = useSite();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const fallbackLinks = [
    { path: "/", ar: "الرئيسية", en: t.nav.home },
    { path: "/tower-solutions", ar: "حلول الأبراج", en: t.nav.towers },
    { path: "/telecom-materials", ar: "مواد الاتصالات", en: t.nav.materials },
    { path: "/projects", ar: "المشاريع", en: t.nav.projects },
    { path: "/industries", ar: "القطاعات", en: t.nav.industries },
    { path: "/how-it-works", ar: "كيف تعمل المنصة", en: t.nav.howItWorks },
    { path: "/partners", ar: "الشركاء", en: t.nav.partners },
    { path: "/about", ar: "من نحن", en: t.nav.about },
    { path: "/contact", ar: "تواصل معنا", en: t.nav.contact },
  ];
  const links = ((settings?.navigation?.length ? settings.navigation : fallbackLinks) || []).filter((x) => x.enabled !== false);
  const identity = settings?.identity || {};
  const logo = assetUrl(identity.logo_url);

  return (
    <header data-testid="site-header" className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${scrolled ? "bg-[#0A1223]/90 backdrop-blur-xl border-b border-white/5 py-3" : "bg-transparent py-5"}`}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8 flex items-center justify-between gap-4">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-2.5 shrink-0">
          {logo ? <img src={logo} alt={identity.site_name || "TowerLink"} className="h-10 max-w-[220px] object-contain" /> : <>
            <span className="grid place-items-center w-9 h-9 bg-[#D4AF37] text-[#0A1223]"><RadioTower size={20} strokeWidth={2.2} /></span>
            <span className="font-heading font-extrabold text-white text-lg tracking-tight leading-none">{identity.site_name || "TowerLink"}<span className="text-slate-300 font-medium ms-1 hidden sm:inline">{identity.site_suffix || "Platform"}</span></span>
          </>}
        </Link>

        <nav className="hidden lg:flex items-center gap-6">
          {links.map((l) => <NavLink key={`${l.path}-${l.id || ""}`} to={l.path} className={({ isActive }) => `text-sm font-medium transition-colors duration-200 ${isActive ? "text-[#D4AF37]" : "text-slate-300 hover:text-white"}`}>{lang === "ar" ? (l.ar || l.en) : (l.en || l.ar)}</NavLink>)}
        </nav>

        <div className="flex items-center gap-3">
          <button onClick={toggleLang} data-testid="lang-toggle" className="hidden sm:flex items-center gap-1.5 text-sm font-medium text-slate-300 hover:text-[#D4AF37] transition-colors"><Globe size={16} />{lang === "en" ? "العربية" : "EN"}</button>
          <button className="lg:hidden text-white" onClick={() => setOpen((o) => !o)} data-testid="mobile-menu-toggle" aria-label="Menu">{open ? <X size={24} /> : <Menu size={24} />}</button>
        </div>
      </div>

      {open && <div className="lg:hidden mt-3 mx-4 glass p-5 rounded-sm" data-testid="mobile-menu"><div className="flex flex-col gap-1">
        {links.map((l) => <NavLink key={`${l.path}-${l.id || ""}`} to={l.path} onClick={() => setOpen(false)} className={({ isActive }) => `py-2.5 text-base font-medium ${isActive ? "text-[#D4AF37]" : "text-slate-200"}`}>{lang === "ar" ? (l.ar || l.en) : (l.en || l.ar)}</NavLink>)}
        <div className="mt-3 pt-4 border-t border-white/12"><button onClick={toggleLang} className="flex items-center gap-1.5 text-sm text-slate-300"><Globe size={16} /> {lang === "en" ? "العربية" : "English"}</button></div>
      </div></div>}
    </header>
  );
};
export default Header;
